export const experienceData = [
    {
        id: 1,
        company: 'Ebridge',
        jobtitle: 'PHP Developer',
        startYear: '2024 ',
        endYear: ' Present'
    },
    {
        id: 2,
        company: 'Wise360 Solutions',
        jobtitle: 'Backend Developer',
        startYear: 'january,2024 ',
        endYear: ' july,2024'
    },
    {
        id: 3,
        company: 'AntonX',
        jobtitle: 'Laravel Developer',
        startYear: 'August, 2023 ',
        endYear: ' January, 2024'
    },
]